module.exports = "/static/assets/184c344a10392a68baad7b825db5a822.gif";